/** Mock funding clients for localhost dev-auth UI testing (no backend). */

export const MARIE_SAMPLE_ENTITIES = [
  {
    id: 'entity_ms_beauty',
    label: 'Primary',
    entityType: 'LLC',
    businessLegalName: 'MS Beauty Studio LLC',
    dbaName: '',
    einMasked: '**-***1931',
    businessStartDate: '2021-03-13',
    businessAddress: '44 Market Plaza, Orlando, FL',
    status: 'Ready for Analysis',
    owners: [
      {
        id: 'owner_marie',
        name: 'Marie Samuelle',
        role: 'Primary Owner',
        ownershipPercent: 70,
        ssnMasked: '***-**-6789',
        dob: '1988-11-05',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 92000,
        employer: 'Self-employed',
        isPrimary: true,
      },
      {
        id: 'owner_jean',
        name: 'Jean Samuelle',
        role: 'Co-owner',
        ownershipPercent: 30,
        ssnMasked: '***-**-4421',
        dob: '1987-02-14',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 78000,
        employer: 'Self-employed',
        isPrimary: false,
      },
    ],
  },
  {
    id: 'entity_marie_personal',
    label: 'Personal Profile',
    entityType: 'Personal Profile',
    businessLegalName: 'Marie Samuelle',
    dbaName: '',
    einMasked: '',
    businessStartDate: '',
    businessAddress: '',
    status: 'Ready for Analysis',
    owners: [
      {
        id: 'owner_marie',
        name: 'Marie Samuelle',
        role: 'Primary Owner',
        ownershipPercent: 100,
        ssnMasked: '***-**-6789',
        dob: '1988-11-05',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 92000,
        employer: 'Self-employed',
        isPrimary: true,
      },
    ],
  },
  {
    id: 'entity_jean_coowner',
    label: 'Co-owner',
    entityType: 'Co-owner Profile',
    businessLegalName: 'Jean Samuelle',
    dbaName: '',
    einMasked: '',
    businessStartDate: '',
    businessAddress: '',
    status: 'Documents Pending',
    owners: [
      {
        id: 'owner_jean',
        name: 'Jean Samuelle',
        role: 'Co-owner',
        ownershipPercent: 100,
        ssnMasked: '***-**-4421',
        dob: '1987-02-14',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 78000,
        employer: 'Self-employed',
        isPrimary: true,
      },
    ],
  },
  {
    id: 'entity_ms_holdings',
    label: 'Business 2',
    entityType: 'Holding Company',
    businessLegalName: 'MS Holdings LLC',
    dbaName: '',
    einMasked: '**-***8844',
    businessStartDate: '2019-06-01',
    businessAddress: '44 Market Plaza, Orlando, FL',
    status: 'Building',
    owners: [
      {
        id: 'owner_marie',
        name: 'Marie Samuelle',
        role: 'Primary Owner',
        ownershipPercent: 100,
        ssnMasked: '***-**-6789',
        dob: '1988-11-05',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 92000,
        employer: 'Self-employed',
        isPrimary: true,
      },
    ],
  },
  {
    id: 'entity_ms_dba',
    label: 'DBA',
    entityType: 'DBA',
    businessLegalName: 'MS Beauty Studio LLC',
    dbaName: 'MS Beauty DBA',
    einMasked: '**-***1931',
    businessStartDate: '2021-03-13',
    businessAddress: '44 Market Plaza, Orlando, FL',
    status: 'Ready for Analysis',
    owners: [
      {
        id: 'owner_marie',
        name: 'Marie Samuelle',
        role: 'Primary Owner',
        ownershipPercent: 100,
        ssnMasked: '***-**-6789',
        dob: '1988-11-05',
        personalAddress: '211 Palm Ridge Dr, Orlando, FL',
        income: 92000,
        employer: 'Self-employed',
        isPrimary: true,
      },
    ],
  },
];

export const JOHN_SAMPLE_ENTITIES = [
  {
    id: 'entity_jm_logistics',
    label: 'Primary',
    entityType: 'LLC',
    businessLegalName: 'JM Logistics Group',
    dbaName: '',
    einMasked: '**-***5521',
    businessStartDate: '2018-04-10',
    businessAddress: '1200 NW 7th Ave, Miami, FL',
    status: 'Documents Pending',
    owners: [
      {
        id: 'owner_john',
        name: 'John Morancy',
        role: 'Primary Owner',
        ownershipPercent: 100,
        ssnMasked: '***-**-3310',
        dob: '1985-07-22',
        personalAddress: '88 Coral Way, Miami, FL',
        income: 86000,
        employer: 'Self-employed',
        isPrimary: true,
      },
    ],
  },
];

export const DEV_MOCK_FUNDING_CLIENTS = [
  {
    id: 'fcl_dev_marie_001',
    clientCode: 'FG-CL-000001',
    agencyId: 'agency_internal_001',
    name: 'Marie Samuelle',
    initials: 'MS',
    businessName: 'MS Beauty Studio LLC',
    legalBusinessName: 'MS Beauty Studio LLC',
    email: 'marie@example.com',
    phone: '+1 407 555 0198',
    creditScore: 724,
    monthlyRevenue: 15500,
    requestedAmount: 48000,
    readinessScore: 82,
    readinessTier: 'Good',
    documentStatus: 'Complete',
    status: 'Ready for Analysis',
    clientType: 'Sample',
    isSample: true,
    selectedEntityId: 'entity_ms_beauty',
    entities: MARIE_SAMPLE_ENTITIES,
    updatedAt: '2026-07-02T12:00:00.000Z',
  },
  {
    id: 'fcl_dev_john_002',
    clientCode: 'FG-CL-000002',
    agencyId: 'agency_internal_001',
    name: 'John Morancy',
    initials: 'JM',
    businessName: 'JM Logistics Group',
    email: 'john@example.com',
    phone: '+1 786 555 0142',
    creditScore: 680,
    monthlyRevenue: 22000,
    requestedAmount: 15000,
    readinessScore: 68,
    readinessTier: 'Needs Work',
    documentStatus: 'Partial',
    status: 'Documents Pending',
    clientType: 'Sample',
    isSample: true,
    selectedEntityId: 'entity_jm_logistics',
    entities: JOHN_SAMPLE_ENTITIES,
    updatedAt: '2026-06-28T12:00:00.000Z',
  },
];

export const DEV_MOCK_ROSTER_STATS = {
  fcl_dev_marie_001: {
    lastApplicationDate: '2025-11-13',
    totalApprovalAmount: 48000,
    totalDenied: 1,
  },
};

export const DEV_MOCK_IDENTITY_PROFILES = [
  {
    id: 'fidp_dev_primary',
    agencyId: 'agency_internal_001',
    clientId: 'fcl_dev_marie_001',
    profileLabel: 'Identity & Business 1',
    isPrimary: true,
    ownerName: 'Marie Samuelle',
    ownershipPercentage: 100,
    ssnMasked: '***-**-6789',
    ssnLast4: '6789',
    dob: '1988-11-05',
    fullEin: '88-4821931',
    businessLegalName: 'MS Beauty Studio LLC',
    businessStartDate: '2021-03-13',
    employerName: 'Self-employed',
    timeLiveInHouseYears: 4,
    timeLiveInHouseMonths: 0,
    timeWorkingAtYears: 6,
    timeWorkingAtMonths: 0,
    personalIncome: 92000,
    businessIncome: 186000,
    personalAddress: '211 Palm Ridge Dr, Orlando, FL',
    businessAddress: '44 Market Plaza, Orlando, FL',
    notes: 'Primary owner profile',
  },
  {
    id: 'fidp_dev_owner2',
    agencyId: 'agency_internal_001',
    clientId: 'fcl_dev_marie_001',
    profileLabel: 'Identity & Business 2',
    isPrimary: false,
    ownerName: 'Jean Samuelle',
    ownershipPercentage: 25,
    ssnMasked: '***-**-1928',
    ssnLast4: '1928',
    dob: '1986-02-18',
    personalAddress: '211 Palm Ridge Dr, Orlando, FL',
    businessAddress: '44 Market Plaza, Orlando, FL',
    employerName: 'Self-employed',
    timeLiveInHouseYears: 3,
    timeLiveInHouseMonths: 4,
    timeWorkingAtYears: 5,
    timeWorkingAtMonths: 2,
    personalIncome: 74000,
    notes: 'Secondary owner profile',
  },
];
